import React, { useEffect, useState } from 'react';

import { message, QRCode } from 'antd';
import { useTranslation } from 'react-i18next';
import { transport } from '../../utils/constants';
import { copyToClipboard, getToken } from '../../utils/helper';
import Button from '../Common/Button/Button';
import Modal from '../Modal/Modal';
import './TwoFA.scss';
import { GoogleAuthenticatorClient } from '../../generated/mlmbox/client/google_authenticator/google_authenticator.client';
import { Empty } from '../../generated/google/protobuf/empty';

const TwoFA: React.FC<{ closeBtn?: Function; btnTo: Function }> = ({ closeBtn, btnTo }) => {
    const [verifyCode, setVerifyCode] = useState('');
    const { t } = useTranslation();
    const twoFAClient = new GoogleAuthenticatorClient(transport);

    useEffect(() => {
        twoFAClient.generate(Empty, { meta: { authorization: getToken() } }).then(({ status, response }) => {
            if (status.code === 'OK') {
                setVerifyCode(response.secretCode);
            }
        });
    }, []);

    return (
        <>
            {!verifyCode ? (
                <></>
            ) : (
                <Modal closeBtn={() => closeBtn && closeBtn()}>
                    <div className="two-fa">
                        <div className="two-fa__title">
                            <h1>{t('twoFA.activate.title')}</h1>
                            <p>
                                {t('twoFA.activate.text.start')}{' '}
                                <span
                                    onClick={() => {
                                        copyToClipboard(verifyCode);
                                        message.success('Скопировано');
                                    }}>
                                    {t('twoFA.activate.text.center')}
                                </span>
                                {t('twoFA.activate.text.end')}
                            </p>
                        </div>

                        {verifyCode && (
                            <div className="qr">
                                <QRCode
                                    onClick={() => {
                                        copyToClipboard(verifyCode);
                                        message.success('Скопировано');
                                    }}
                                    value={`otpauth://totp/TTM?secret=${verifyCode}`}
                                />
                            </div>
                        )}
                        <Button
                            background="var(--gr-b)"
                            color="#fff"
                            title={t('twoFA.activate.btn')}
                            onCick={() => {
                                btnTo();
                                closeBtn &&
                                    setTimeout(() => {
                                        closeBtn();
                                    }, 100);
                            }}
                        />
                    </div>
                </Modal>
            )}
        </>
    );
};

export default TwoFA;
